import { Langs } from "@/app/types";

const InValidLang = ["ru", "kr"];

export const LangKeys = Object.keys(Langs);

export const ValidLang = LangKeys.filter((lang) => !InValidLang.includes(lang));

export const InternalLimitTableIds = [
    276, 422, 26, 27, 31, 30, 32, 33, 34, 36, 37, 39, 510, 511, 512, 513, 514, 515, 516, 517, 40, 42, 43, 45, 55, 56, 50, 49, 48, 54, 57, 58, 64, 62,
    71, 72, 70, 69, 67, 51, 59, 60, 61, 63, 68, 73, 52, 53, 66, 74, 78, 75, 76, 79, 77, 500, 501, 502, 503, 504, 505, 158, 161, 165, 163, 162, 164,
    157, 166, 93, 82, 87, 89, 92, 91, 94, 97, 98, 99, 103, 104, 126, 105, 125, 100, 107, 108, 109, 110, 111, 127, 112, 113, 114, 128, 115, 116, 117,
    118, 119, 120, 121, 129, 130, 122, 123, 124, 133, 134, 135, 136, 137, 132, 138, 144, 139, 140, 141, 142, 145, 146, 143, 479, 131, 463,
];

export const OverseaLimitTableIds = [
    276, 422, 26, 27, 31, 30, 32, 33, 34, 36, 37, 39, 510, 511, 512, 513, 514, 515, 516, 517, 40, 42, 43, 45, 55, 56, 57, 64, 62, 71, 72, 70, 69, 67,
    59, 60, 61, 63, 68, 73, 66, 74, 78, 75, 76, 79, 77, 500, 501, 502, 503, 504, 505, 158, 161, 165, 163, 162, 164, 157, 166, 90, 95, 86, 85, 96, 88,
    81, 84, 83, 89, 92, 91, 94, 97, 98, 99, 103, 104, 126, 105, 125, 100, 107, 108, 109, 110, 111, 127, 112, 113, 114, 128, 115, 116, 117, 118, 119,
    120, 121, 129, 130, 122, 123, 124, 133, 134, 135, 136, 137, 132, 138, 144, 139, 140, 141, 142, 145, 146, 143, 479, 131, 463,
];

export const aidrawLibs = [
    11, 12, 247, 55, 56, 50, 49, 57, 62, 51, 60, 61, 63, 52, 53, 78, 75, 76, 79, 501, 503, 151, 163, 154, 152, 153, 155, 164, 156, 157, 159, 103, 104,
    126, 106, 107, 108, 109, 110, 111, 112, 113, 114, 128, 115, 116, 117, 118, 119, 120, 121, 122, 101, 123, 124, 133, 134, 132, 142, 478, 228, 227,
    229, 231, 213, 222, 205, 221,
];

export const limitThemeId = [
    75, 87, 88, 41, 48, 43, 89, 72, 73, 74, 76, 77, 78, 60, 79, 47, 51, 62, 92, 63, 64, 50, 49, 66, 67, 68, 91, 69, 70, 71, 55, 93, 82, 83, 42, 45,
    84, 85, 40, 86, 51, 87, 81, 45, 79, 71,
];
export const limitThemeColorId = [
    74, 82, 41, 47, 42, 129, 130, 131, 132, 79, 80, 30, 39, 48, 112, 113, 114, 115, 116, 71, 73, 34, 76, 49, 43, 118, 119, 120, 125, 124, 123, 46, 44,
    45, 4, 122, 31, 35, 50, 40, 133, 134, 135, 136, 43, 100, 101, 103, 104, 105, 106, 107, 45, 46, 109, 110, 111,
];
